import { render, staticRenderFns } from "./StatisticsMerchants.vue?vue&type=template&id=3f0ba979&scoped=true&"
import script from "./StatisticsMerchants.vue?vue&type=script&lang=js&"
export * from "./StatisticsMerchants.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsMerchants.vue?vue&type=style&index=0&id=3f0ba979&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0ba979",
  null
  
)

export default component.exports